/**
 * @generated SignedSource<<c5b1bd5efb05f97e74d1a1942844294d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateCalendarEventInput = {
  calendarId: string;
  endAt: string;
  isAllDayEvent: boolean;
  startAt: string;
  title: string;
};
export type CalendarTeamEventCreateScreenCreateCalendarEventMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateCalendarEventInput;
};
export type CalendarTeamEventCreateScreenCreateCalendarEventMutation$data = {
  readonly createCalendarEvent: {
    readonly createdAt: {
      readonly isoString: string;
    };
    readonly endAt: {
      readonly isoString: string;
    };
    readonly id: string;
    readonly isAllDayEvent: boolean;
    readonly startAt: {
      readonly isoString: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventItem_event">;
  };
};
export type CalendarTeamEventCreateScreenCreateCalendarEventMutation = {
  response: CalendarTeamEventCreateScreenCreateCalendarEventMutation$data;
  variables: CalendarTeamEventCreateScreenCreateCalendarEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAt",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "endAt",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDayEvent",
  "storageKey": null
},
v10 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "WEEKDAY_AND_DATE"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"WEEKDAY_AND_DATE\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarTeamEventCreateScreenCreateCalendarEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CalendarEvent",
        "kind": "LinkedField",
        "name": "createCalendarEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CalendarTeamEventItem_event"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CalendarTeamEventCreateScreenCreateCalendarEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CalendarEvent",
        "kind": "LinkedField",
        "name": "createCalendarEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "storeCalendar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "startAtDateAndTime",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "startAt",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": "endAtDateAndTime",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "endAt",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": "startAtWeekdayAndDate",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "startAt",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": "endAtWeekdayAndDate",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "endAt",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": "endAtTime",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "endAt",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "style",
                    "value": "TIME_ONLY"
                  }
                ],
                "kind": "ScalarField",
                "name": "storeFormattedDate",
                "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "appendNode",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createCalendarEvent",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          },
          {
            "kind": "Literal",
            "name": "edgeTypeName",
            "value": "CalendarTeamCalendarEventsEdge"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f5d992e84ce77b1fde0408a4c61bfd1a",
    "id": null,
    "metadata": {},
    "name": "CalendarTeamEventCreateScreenCreateCalendarEventMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarTeamEventCreateScreenCreateCalendarEventMutation(\n  $input: CreateCalendarEventInput!\n) {\n  createCalendarEvent(input: $input) {\n    id\n    startAt {\n      isoString\n    }\n    endAt {\n      isoString\n    }\n    createdAt {\n      isoString\n    }\n    isAllDayEvent\n    ...CalendarTeamEventItem_event\n  }\n}\n\nfragment CalendarOverviewEventItemDateTime_event on CalendarEvent {\n  startAtDateAndTime: startAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  endAtDateAndTime: endAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  startAtWeekdayAndDate: startAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtWeekdayAndDate: endAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtTime: endAt {\n    ...StoreFormattedDate_1b2lNL\n  }\n  isAllDayEvent\n}\n\nfragment CalendarTeamEventItem_event on CalendarEvent {\n  title\n  storeCalendar {\n    color\n    id\n  }\n  ...CalendarOverviewEventItemDateTime_event\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment StoreFormattedDate_1hpjGt on StoreZonedDate {\n  storeFormattedDate(style: WEEKDAY_AND_DATE)\n}\n\nfragment StoreFormattedDate_2LP8ap on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n"
  }
};
})();

(node as any).hash = "f52ffdb2a0ef750a187c04964c2fe437";

export default node;
